import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { api } from '../services/api';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { loadFromStorage } = useAuthStore();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionMatch = hash.match(/session_id=([^&]+)/);
    if (!sessionMatch) {
      navigate('/');
      return;
    }

    const sessionId = sessionMatch[1];

    (async () => {
      try {
        const res = await api.post('/auth/google-session', { session_id: sessionId });

        // Admin 2FA required
        if (res.data.requires_2fa) {
          // Store 2FA state and redirect to landing for 2FA input
          sessionStorage.setItem('pending_2fa_email', res.data.email);
          sessionStorage.setItem('pending_2fa_message', res.data.message);
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/?2fa=1');
          return;
        }

        const { access_token, user } = res.data;
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));
        loadFromStorage();

        // Remove hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        if (user.role === 'driver') {
          navigate('/driver/dashboard');
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/');
      }
    })();
  }, [navigate, loadFromStorage]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-orange-500 mx-auto mb-4" />
        <p className="text-slate-600 font-medium">Anmeldung wird verarbeitet...</p>
      </div>
    </div>
  );
}
